import React, { useState } from "react";
import { fetchWeather } from "./api/fetchWeather.js";
import "./App.css";
let city;

const App = () => {
  const [query, setQuery] = useState("");
  const [weather, setWeather] = useState({});

  const search = async (e) => {
    if (e.key === "Enter") {
			e.target.blur();
      if (query === "") {
        city = (
          <div className="city">
            <h1 className="city-name">Please enter a city name</h1>
          </div>
        );
        setWeather({});
      } else {
        const data = await fetchWeather(query).catch((error) => {
          console.log(error);
        });

        if (data === undefined) {
          city = (
            <div className="city">
              <h1 className="city-name">This city doesnt exist</h1>
            </div>
          );
          setQuery("");
        } else {
          city = (
            <div className="city">
              <h2 className="city-name">
                <span>{data.name}</span>
                <sup>{data.sys.country}</sup>
              </h2>
              <div className="city-temp">
                {Math.round(data.main.temp)}
                <sup>&deg;</sup>
              </div>
              <div className="info">
                <img
                  className="city-icon"
                  src={`https://openweathermap.org/img/wn/${data.weather[0].icon}@2x.png`}
                  alt={data.weather[0].description}
                />
                <p>{data.weather[0].description}</p>
                <p>{`feels like ${Math.round(
                  data.main.feels_like
                )} degrees`}</p>
              </div>
            </div>
          );
          setQuery("");
					setWeather(data);
        }
      }
    }
  };

  return (
    <div className="main-container">
      <input
        type="text"
        className="search"
        placeholder="Enter city name"
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        onKeyPress={search}
      />
      {city}
    </div>
  );
};

export default App;

